import { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Button, Container, Form, Row
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { alertError, alertSuccess } from '../../store/ducks/alert';

export class ResetPassword extends React.Component {
  formRef = React.createRef();

  resetPassword = async () => {
    const { dispatch, history, location } = this.props;

    try {
      await Auth.forgotPasswordSubmit(
        location.state.userName,
        this.formRef.current.code.value,
        this.formRef.current.password.value
      );

      dispatch(alertSuccess('Successfully reset password. Please log in again.'));
      history.push('/login');
    } catch (err) {
      let errorMsg = err.message || JSON.stringify(err);

      if (err.code === 'CodeMismatchException') {
        errorMsg = 'Invalid passcode provided, please try again.';
      }

      dispatch(alertError(errorMsg));
    }
  };

  passwordPolicyValidation = async () => {
    const { dispatch } = this.props;
    const passwordRegEx = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,99}$/;

    if (!this.formRef.current.password.value.match(passwordRegEx)) {
      dispatch(alertError('Password Policy: Minimum length of 8 characters, one lowercase, one uppercase, one numeric digit and one special character.'));
    } else await this.resetPassword();
  };

  handleConfirmPasswordCheck = async () => {
    const { dispatch } = this.props;

    if (this.formRef.current.password.value !== this.formRef.current.confirmpassword.value) {
      dispatch(alertError('Please make sure your passwords match.'));
    } else await this.passwordPolicyValidation();
  };

  render() {
    return (
      <Container fluid>
        <div className="p-5">
          <h1 className="text-light">Set new password</h1>
          <p className="text-dark">
            Enter the
            <strong> passcode</strong>
            {' '}
            we sent and your
            {' '}
            <strong> new password</strong>
            .
          </p>
          <Form ref={this.formRef}>
            <Row>
              <div className="col-lg-5 mb-3">
                <div className="input-group">
                  <Form.Control required type="text" name="code" placeholder="Passcode" />
                </div>
              </div>
            </Row>
            <div className="input-group">
              <Form.Control required type="password" name="password" placeholder="New password" />
              <Form.Control
                required
                type="password"
                name="confirmpassword"
                placeholder="Confirm new password"
              />
              <div className="input-group-append">
                <Button
                  onClick={() => this.handleConfirmPasswordCheck()}
                  className="btn btn-primary"
                  type="button"
                >
                  {' '}
                  Go!
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </Container>
    );
  }
}

ResetPassword.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      userName: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default withRouter(connect()(ResetPassword));
